import colormap from 'colormap';
import { join, replace, reverse } from 'es-toolkit/compat';

export const reverseColorMapPrefix = 'reverse-';

export const getColorMapWithReverseSupport = ({ colormap: colorMapName, ...spec }: Parameters<typeof colormap>[0]) => {
  const isReverseColorMap = typeof colorMapName === 'string' && colorMapName.startsWith(reverseColorMapPrefix);
  const baseColorMapColors = colormap({
    colormap: isReverseColorMap ? replace(colorMapName, reverseColorMapPrefix, '') : colorMapName,
    ...spec,
  });
  if (isReverseColorMap) {
    reverse(baseColorMapColors);
  }
  return baseColorMapColors;
};

export const getColorMapLinearGradient = (colorMapName: string) => {
  const colorMapColors = getColorMapWithReverseSupport({
    colormap: colorMapName,
    nshades: 20,
    format: 'hex',
    alpha: 1,
  });
  return `linear-gradient(to right, ${join(colorMapColors, ', ')})`;
};
